import { createAction } from 'redux-actions';
import { url_getMedicalCountryByMeta} from '../../api/urls'
import { GET_MEDICATIONS_BY_COUNTRY} from '../constants/get';
import api from '../../api';

export const getMedicalCountryByMeta =  createAction(GET_MEDICATIONS_BY_COUNTRY, (meta)=> api.get(url_getMedicalCountryByMeta(meta)));
